import useActivityTimeline from "@/modules/lead-page/new/hooks/activity-timline.hook";
import { Box, useTheme } from "@mui/material";
import ActivityDetails from "@/modules/lead-page/new/components/activity/activity-details";
import AddComment from "./add-comment";
import { ActivityScrollProvider } from "../../context/activity-scroll-context";

const LastActivityCard = ({
  addComment = (
    <AddComment lastActivityCardStyle addCommentButtonText="Add Comment" />
  ),
  onNavigateToTrack,
}: {
  addComment?: React.ReactNode;
  onNavigateToTrack?: (trackUId: string) => void;
}) => {
  const { mostRecentActivityItem } = useActivityTimeline();
  const theme = useTheme();

  if (!mostRecentActivityItem) return null;

  return (
    <Box
      sx={{
        padding: theme.nawy.spacing.sm,
        gap: theme.nawy.spacing.xs,
        borderRadius: theme.nawy.radius.lg,
        border: `1px solid ${theme.nawy.colors.semantic.border.secondary}`,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <ActivityDetails item={mostRecentActivityItem} lastActivityCardStyle onNavigateToTrack={onNavigateToTrack} />

      <ActivityScrollProvider>
        <Box
          sx={{
            borderRadius: theme.nawy.radius.xl,
          }}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          {addComment}
        </Box>
      </ActivityScrollProvider>
    </Box>
  );
};

export default LastActivityCard;
